export const now = (): string =>
    (new Date( (new Date()).toDateString())).toISOString()

export const normaliseDate = (date: Date): Date =>
    new Date(`${date.toISOString().substring(0,10)}T12:00:00.000Z`)
